<template>
  <select
    :name="selectName"
    :id="selectId"
    class="border border-gray-300 rounded h-10 px-4"
    :value="modelValue"
    @input="$emit('update:modelValue', $event.target.value)"
  >
    <option disabled value="">{{ placehoder }}</option>
    <option v-for="option in options" :value="option.value" :key="option.value">
      {{ option.text }}
    </option>
  </select>
</template>

<script>
export default {
  components: {},
  props: {
    modelValue: [String, Number],
    selectName: String,
    selectId: String,
    options: Array,
    placehoder: { type: String, default: "Alege" },
  },
  emits: ["update:modelValue"],
};
</script>

<style></style>
